<template>
  <input :type="parseCellType(ruleType)"
         ref="inputBox"
         @keyup="isValid"
         :min="min"
         :max="max"
         :class="[{'invalid': invalid}, ruleName]"
         @blur="checkBlur"
         :placeholder="translateValue()"
         :disabled="ruleDisabled"
         v-model="workingValue">
</template>

<script>
import numberIs from 'lodash/isNumber';
import rulesProps from '../mixins';

export default {
  name: 'InputBox',
  data() {
    return {
      workingValue: null,
      invalid: false,
      timeout: null,
      min: 0,
      max: 1000,
    };
  },
  mixins: [rulesProps],
  props: {
    activeRulePlatform: {
      type: String,
      default: '',
    },
  },
  methods: {
    // eslint-disable-next-line consistent-return
    isValid(evt, mountedCheck = false) {
      clearTimeout(this.timeout);
      const value = !mountedCheck ? +evt.target.value : +evt.value;
      if (this.parseCellType(this.ruleType) === 'number') {
        if (this.$store.state.activeMinorModule === 'oddsMgmt') {
          const dotValue = evt.target.value.replace(',', '.');
          const indexOfDot = dotValue.indexOf('.');
          const invalid = indexOfDot >= 0 ? dotValue.slice(indexOfDot + 1).length > 2 : false;
          if (invalid) {
            this.workingValue = (+dotValue).toFixed(2);
          }
          this.$emit('odds-mgmt-odd-update', {
            key: this.ruleKey,
            value: this.workingValue,
          });
          if (this.workingValue) {
            this.$emit('input-section-box-update', {
              key: this.ruleKey,
              value: +this.workingValue,
            });
          }
          return true;
        }
        this.invalid = false;
        const isNumber = numberIs(value) ? value : null;
        if ((evt.target.value === '' && this.activeRulePlatform !== 'general')
          || ((isNumber === 0 || isNumber) && isNumber >= this.min && isNumber <= this.max)) {
          this.invalid = false;
          this.$emit('rule-input-error-remove', this.ruleKey);
        } else {
          this.invalid = true;
          this.$emit('rule-input-error', this.ruleKey);
        }
      }
      if (!this.invalid && !mountedCheck) {
        const parsedWorkingValue = this.parseCellType(this.ruleType) === 'number'
          && this.workingValue !== ''
          ? +this.workingValue : this.workingValue;
        this.$emit('input-section-box-update', {
          key: this.ruleKey,
          value: parsedWorkingValue,
        });
        if (this.ruleAction) {
          if (evt.key === 'Enter' && this.ruleAction === 'enter') {
            this.emitAction();
          } else if (this.ruleAction === 'setTimeout') {
            this.timeout = setTimeout(() => {
              this.emitAction();
            }, 2500);
          }
        }
      }
    },
    checkBlur() {
      if (this.$store.state.activeMinorModule === 'oddsMgmt') {
        if (+this.workingValue < 1) {
          this.workingValue = this.$store.state.oddsMgmtEditModeData
            .data[this.$store.state.oddsMgmtRow].default_odd;
          this.$emit('input-section-box-update', {
            key: 'new_odd',
            value: +this.workingValue,
          });
        } else {
          this.workingValue = (+this.workingValue).toFixed(2);
        }
      }
    },
    parseCellType(type) {
      const splitType = type.split('-');
      return splitType.length > 1 ? splitType[1] : splitType[0];
    },
    emitAction() {
      this.$emit('input-section-box-action', {
        action: this.ruleAction,
        value: this.workingValue,
      });
    },
    translateValue() {
      return this.$store.state.translations[this.rulePlaceholder] || this.rulePlaceholder;
    },
  },
  mounted() {
    this.workingValue = this.ruleValue;
    this.min = this.ruleContent ? this.ruleContent.validation.minimum : 0;
    this.max = this.ruleContent ? this.ruleContent.validation.maximum : 1000;
  },
  watch: {
    ruleValue(newValue) {
      this.workingValue = newValue;
    },
  },
};
</script>

<style lang="scss" scoped>
  input {
    height: 100%;
    &.invalid {
      border: 1px solid #f6903d;
      color: #f6903d;
    }
    &.cells {
      border: 1px solid #d3dadd;
      color: #6b7585;
      height: 29px;
      width: 100%;
      min-width: 100px;
      padding: 5px;
    }
  }
</style>
